<template>
  <div class="countdown">
    <!-- 显示格式化后的时间 -->
    <span v-if="!hideDays && days > 0">{{ days }} Dias </span>
    <span>{{ hours }}</span
    >:<span>{{ minutes }}</span
    >:<span>{{ seconds }}</span>
  </div>
</template>

<script>
export default {
  name: 'CountdownTimer',
  props: {
    initialTime: {
      // 初始时间（秒）
      type: Number,
      required: true,
      validator: value => value > 0
    },
    autoStart: {
      // 是否自动开始
      type: Boolean,
      default: true
    },
    hideDays: {
      // 隐藏天数显示
      type: Boolean,
      default: false
    }
  },
  emits: ['timeup'], // 自定义事件

  data() {
    return {
      remainingTime: this.initialTime,
      timer: null,
      isPaused: false
    };
  },

  computed: {
    // 时间格式化计算
    days() {
      return Math.floor(this.remainingTime / 86400);
    },
    hours() {
      return String(Math.floor((this.remainingTime % 86400) / 3600)).padStart(
        2,
        '0'
      );
    },
    minutes() {
      return String(Math.floor((this.remainingTime % 3600) / 60)).padStart(
        2,
        '0'
      );
    },
    seconds() {
      return String(this.remainingTime % 60).padStart(2, '0');
    }
  },

  mounted() {
    if (this.autoStart) this.start();
  },

  beforeUnmount() {
    clearInterval(this.timer);
  },

  methods: {
    start() {
      if (this.timer) return;

      this.timer = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--;
        } else {
          this.stop();
          this.$emit('timeup');
        }
      }, 1000);
    },

    pause() {
      clearInterval(this.timer);
      this.timer = null;
      this.isPaused = true;
    },

    resume() {
      if (!this.isPaused) return;
      this.start();
      this.isPaused = false;
    },

    reset() {
      this.stop();
      this.remainingTime = this.initialTime;
      this.start();
    },

    stop() {
      clearInterval(this.timer);
      this.timer = null;
      this.isPaused = false;
    }
  }
};
</script>
